module.exports = __webpack_public_path__ + "img/You have waste.68783c41.svg";